import React from 'react'
import { Flex, Button, Box, Text } from 'theme-ui'
import styled from '@emotion/styled'

const StyledButton = styled(Button)`
  width: 20px;
  &:focus {
    outline: none;
  }
`

function ProductCounter({ currentAmount, increaseAmount, decreaseAmount }) {
  return (
    <Flex sx={{ flex: 1, alignItems: 'center' }}>
      <Box sx={{ width: '33%', textAlign: 'left' }}>
        <StyledButton
          onClick={decreaseAmount}
          aria-label={'Decrease product amount by 1'}
          variant="increase-decrease"
          outline="none"
        >
          -
        </StyledButton>
      </Box>

      <Box sx={{ width: '33%', textAlign: 'center' }}>
        <Text textAlign="center">{currentAmount}</Text>
      </Box>
      <Box sx={{ width: '33%', textAlign: 'right' }}>
        <StyledButton
          onClick={increaseAmount}
          aria-label={'Increase product amount by 1'}
          variant="increase-decrease"
        >
          +
        </StyledButton>
      </Box>
    </Flex>
  )
}

export default ProductCounter
